// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.delete-button {
  display: flex;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: #97002e;
}

.short-description-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.manual-edit-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid #ccc;
  border-radius: 16px;
  background: white;
  color: #666;
  cursor: pointer;
  padding: 5px 12px;
  font-size: 13px;
  flex-shrink: 0;
  transition: color 0.2s, background-color 0.2s, border-color 0.2s;
}
.manual-edit-button:hover {
  color: #0b2d71;
  background-color: #e3eaf8;
  border-color: #0b2d71;
}
.manual-edit-button.active {
  color: #0b2d71;
  background-color: #e3eaf8;
  border-color: #0b2d71;
}

.manual-edit-label {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.short-description-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-shrink: 0;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}

::ng-deep .mat-mdc-select-panel:has(.valve-type-search-container) {
  padding-top: 0 !important;
}

::ng-deep .valve-type-search-container {
  padding: 8px 8px 4px;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1000;
}
::ng-deep .valve-type-search-container .valve-type-search-input {
  width: 100%;
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
  outline: none;
}
::ng-deep .valve-type-search-container .valve-type-search-input:focus {
  border-color: #1976d2;
}

.back-button {
  background: none;
  border: none;
  color: #0B2D71;
  font-weight: bolder;
  cursor: pointer;
  padding: 8px 0;
  font-size: 14px;
}
.back-button:hover {
  text-decoration: underline;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  margin-bottom: 4px;
}

.page-title {
  font-weight: 900;
  color: #0B2D71;
  margin: 0;
}

.page-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.mode-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 10px;
  border-radius: 12px;
  letter-spacing: 0.5px;
}

.clone-badge {
  background: #e3eaf8;
  color: #0B2D71;
}

.create-badge {
  background: #e8f5e9;
  color: #1b5e20;
}

.valve-edit-form {
  max-width: 900px;
}

.section {
  margin-bottom: 24px;
}

.section-title {
  font-weight: 700;
  font-size: 16px;
  text-transform: lowercase;
  color: #0B2D71;
  margin-bottom: 8px;
}
.section-title.no-margin {
  margin: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 0 16px;
}

.form-field {
  display: flex;
  flex-direction: column;
}
.form-field--full {
  grid-column: 1/-1;
}

.field-label {
  font-size: 13px;
  font-weight: 600;
  text-transform: lowercase;
  margin-bottom: 2px;
  color: #333;
}
.field-label.required::after {
  content: " *";
  color: #c62828;
}

.full-width {
  width: 100%;
}

.display-value {
  display: block;
  font-size: 14px;
  color: #333;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 4px;
  min-height: 40px;
  line-height: 24px;
}

.params-table {
  width: 100%;
  border-collapse: collapse;
}
.params-table td {
  padding: 4px 8px;
  vertical-align: middle;
}

.params-label {
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  width: 140px;
  color: #333;
}

.params-value {
  width: 100%;
}

.size-range {
  display: flex;
  align-items: center;
  gap: 8px;
}

.size-field {
  width: 110px;
}

.size-sep {
  font-size: 13px;
  color: #666;
}

.properties-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 8px;
}
.properties-table th {
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  padding: 6px 8px;
  border-bottom: 1px solid #e0e0e0;
  color: #555;
}
.properties-table td {
  padding: 2px 8px;
  vertical-align: middle;
}

.col-name {
  width: 220px;
}

.col-value {
  width: 100%;
}

.col-action {
  width: 40px;
}

.prop-name-static {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
}

.prop-name-cell,
.prop-value-cell {
  vertical-align: middle;
}

.compact ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.compact ::ng-deep .mat-mdc-text-field-wrapper {
  padding-bottom: 0;
}

.properties-hint {
  font-size: 13px;
  color: #888;
  padding: 12px 0;
}

.add-property-row {
  margin-top: 4px;
}

.progress-bar-container {
  height: 4px;
  margin-bottom: 4px;
}

.action-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 32px;
  padding-bottom: 32px;
}

.button {
  background-color: #0B2D71;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
}
.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.button:not(:disabled):hover {
  background-color: #0d3a8a;
}

.secondary {
  background: none;
  border: 1px solid #0B2D71;
  color: #0B2D71;
  padding: 10px 24px;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
}
.secondary:hover {
  background-color: #f0f4ff;
}

.properties-loading {
  padding: 8px 0 4px;
}

.properties-skeleton-row {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}

.skeleton-cell {
  border-radius: 4px;
  background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.4s ease-in-out infinite;
  height: 36px;
}

.skeleton-name {
  flex: 0 0 35%;
}

.skeleton-value {
  flex: 1;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
.properties-loading-hint {
  font-size: 13px;
  color: #888;
  margin: 10px 0 4px;
  font-style: italic;
}

.revision-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0 24px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #555;
}
.revision-meta strong {
  color: #333;
}

.rejected-status, .retired-status, .published-status, .ready-to-publish-status, .review-rejected-status, .review-status, .draft-status {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.draft-status {
  color: #751569;
  background-color: #f5e8f4;
  border: 1px solid #c98ac4;
}

.review-status {
  color: #1a7fa0;
  background-color: #e5f6fd;
  border: 1px solid #5cc0e7;
}

.review-rejected-status {
  color: #a02020;
  background-color: #fdf0f0;
  border: 1px solid #d9534f;
}

.ready-to-publish-status {
  color: #0066b2;
  background-color: #e3f0fb;
  border: 1px solid #80b8df;
}

.published-status {
  color: #1a6b3a;
  background-color: #e8f5ee;
  border: 1px solid #7ebc9a;
}

.retired-status {
  color: #555;
  background-color: #f0f0f0;
  border: 1px solid #bbb;
}

.rejected-status {
  color: #9b2020;
  background-color: #fdf0f0;
  border: 1px solid #e09090;
}

.secondary-action {
  background-color: white;
  color: #0B2D71;
  border: 1px solid #0B2D71;
}
.secondary-action:not(:disabled):hover {
  background-color: #f0f4ff;
}
.secondary-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.prop-row-removed {
  color: #6d2a2a;
}
.prop-row-removed:nth-child(even) td {
  background-color: #ffebee !important;
}
.prop-row-removed:nth-child(odd) td {
  background-color: #ffcdd2 !important;
}
.prop-row-removed s {
  text-decoration-color: #c62828;
}

.prop-row-new {
  color: #2a5d2a;
}
.prop-row-new:nth-child(even) td {
  background-color: #e8f5e9 !important;
}
.prop-row-new:nth-child(odd) td {
  background-color: #c8e6c9 !important;
}
.prop-row-new s {
  text-decoration-color: #2e7d32;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
